import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteItem, getAllItems } from "../../../redux/slices/dynamicUiSlice";
import AddItemLoader, { AddItemError } from "./AddItemLoader";
import DynamicItemTableHeader from "./DynamicItemTableHeader";
import CustomTable from "../../../components/table/CustomTable";
import { DynamicItemSearchResultTableBody } from "./DynamicItemTableBody";
import { ITEM_PER_PAGE_DYNAMIC_ITEMS } from "../constants";
import ConfirmModal from "../../../components/ConfirmModal";
import { PreviewModal } from "./PreviewModal";
import AddToSelectedModal from "./AddToSelectedModal";
import useDidMount from "../../../hooks/useDidMount";

export default function DynamicItemSearchContents({ onEditItem }) {

  const { deleting, deleteFlag } = useSelector((state) => state.dynamicUi.items.flags);
  const [itemClicked, setItemClicked] = useState();
  const [itemToSelected, setItemToSelected] = useState();

  const {
    loading,
    error,
    data
  } = useSelector((state) => state.dynamicUi.items.searchResult);

  const dispatch = useDispatch();


  const fetchAllItems = useCallback(() => {
    dispatch(getAllItems());
  }, [dispatch]);

  const removeItem = () => {
    dispatch(deleteItem(itemClicked.id));
  };

  const closeModal = () => {
    setItemClicked(undefined);
  };

  const onPreviewAction = (item) => {
    setItemClicked(undefined);
    setItemToSelected(item);
  };

  useDidMount(() => {
    closeModal();
  }, [deleteFlag]);


  return (
    <>
      {
        error ? <AddItemError errorMsg={error} retry={fetchAllItems} /> :
          <CustomTable>
            <DynamicItemTableHeader />
            {loading ? <AddItemLoader count={ITEM_PER_PAGE_DYNAMIC_ITEMS} /> :
              <DynamicItemSearchResultTableBody onEditItem={onEditItem} setItemToSelected={setItemToSelected}
                setItemClicked={setItemClicked} item={data}/>}
            <tbody>
              <tr>
                <td>
                  <ConfirmModal showModal={!!itemClicked?.delete} onConfirm={removeItem} setShowModal={closeModal}
                    disabled={deleting}>
                    This element will be deleted
                </ConfirmModal>
                  <PreviewModal showModal={!!itemClicked?.preview ? itemClicked : undefined}
                    setShowModal={closeModal} add={true} onConfirm={onPreviewAction} />
                  <AddToSelectedModal showModal={itemToSelected} setShowModal={setItemToSelected} />
                </td>
              </tr>
            </tbody>

          </CustomTable>
      }
    </>
  );
}


